import React from 'react';
import styled, { css } from 'styled-components';
import DragAndDropContainer from '~/components/DragAndDropContainer';
import ImageUploadTextButton from '~/components/ImageUploadTextButton';
import { DHEditor } from '~/components/PluginsEditor/types';
import { acceptedFileTypes } from '../..';
import insertImageAction from '../../../../elements/Image/insertAction';

export type Props = {
  dataTestId?: string;
  editor: DHEditor;
  userId: string;
  onClose: () => void;
};

const UploadFileContainer: React.FC<Props> = ({
  dataTestId,
  editor,
  onClose,
  userId,
  ...rest
}) => (
  <Container data-testid={dataTestId} {...rest}>
    <StyledDragDropContainer
      handleDrop={files =>
        insertImageAction(editor, files, userId, () => onClose())
      }
      uploading={false}
      acceptedFileTypes={acceptedFileTypes}
    >
      <ImageUploadTextButton
        onUpload={files => {
          if (files) {
            onClose();
            insertImageAction(editor, files, userId);
          }
        }}
        uploading={false}
      />
    </StyledDragDropContainer>
  </Container>
);

const Container = styled.div<{}>``;

const StyledDragDropContainer = styled(DragAndDropContainer)<{}>(
  ({ theme }) => css`
    border: ${theme.getTokens().border.width.s} dashed
      ${theme.color('grey', 'light')};
    border-radius: ${theme.getTokens().border.radius.base};
    padding: ${theme.space('m')};
    display: flex;
    align-items: center;
    width: auto;
    height: 150px;
  `,
);

export default UploadFileContainer;
